import { GELADA_JWT_KEYS } from '../useJwtDecoder';

const GELADA_ACCESS_TOKEN_KEYS = [...GELADA_JWT_KEYS, 'custom_build', 'permissions', 'role', 'services', 'status'] as const;

export { GELADA_ACCESS_TOKEN_KEYS };
